export enum RoleType {
  organization = 0,
  document = 1,
  portal = 2,
  group = 3,
  peerDocument = 4,
}

export const RoleTypeName = {
  [RoleType.organization]: 'Organizational',
  [RoleType.document]: 'Document',
  [RoleType.portal]: 'Portal',
  [RoleType.group]: 'Group',
  [RoleType.peerDocument]: 'Peer Document',
};

